/*
 * @Author: Teemo Ding
 * @Date: 2021-07-16 16:57:46
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:01:22
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentEditPage/PaymentAmountLimitation/index.tsx
 */
import EditableTable from '@/src/components/EditableTable/EditableTable';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { limitationColumns } from '../config';
import css from '../css.module.less';

const PaymentAmountLimitation = ({
  Limitations = [],
  supportedCurrencyCodes = [],
  handleAmountLimitChange,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const amountOnChange = (current, e) => {
    const data = Limitations.map((item) => {
      if (current == item.currencyCode) {
        return { ...item, ...e };
      } else {
        return item;
      }
    });
    handleAmountLimitChange(data);
  };
  return (
    <SectionWrapper
      titleClassName={css.titleContainerAll}
      rightPart={''}
      title={getI18n('storePayment.paymentEditPage.paymentAmountLimitation')}>
      {disabled ? null : (
        <EditableTable
          id={'stock'}
          rowKey={'currencyCode'}
          bordered
          rowClassName={(record) =>
            supportedCurrencyCodes.includes(record.currencyCode)
              ? css.row
              : css.rowDisabled
          }
          className={css.table}
          pagination={false}
          columns={limitationColumns(
            { amountOnChange },
            {
              getI18n,
              isEditable: (code) => supportedCurrencyCodes.includes(code),
            },
          )}
          dataSource={Limitations}
        />
      )}
    </SectionWrapper>
  );
};

export default PaymentAmountLimitation;
